module.exports = __webpack_public_path__ + "static/media/35.123f1aaa.JPG";